import MyAccountForm from "../../components/views/my-account";

function MyAccountPage() {
  return <MyAccountForm></MyAccountForm>
}

export default MyAccountPage;
